import { Navigate, Outlet } from 'react-router-dom'
import { checkLogin } from '../utilities/helpers'
import { LOGIN } from 'configs/path'

const PrivateRouter = () => {
  return checkLogin() ? <Outlet /> : <Navigate to={LOGIN} />
}

export default PrivateRouter
